var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Button as AriaButton, TooltipTrigger, Tooltip, OverlayArrow } from "react-aria-components";
import { useButton } from "react-aria";
import * as style from "./Button.module.css";
import { getClassNameForSize, getClassNameForPadding, getClassNameForColor } from "./buttonUtils";
import { useRef } from "react";
const Button = ({
  size = "large",
  padding = "default",
  color = "primary",
  type = "button",
  filled = false,
  disabled = false,
  pending = false,
  tooltip,
  tooltipPosition = "top",
  tooltipCrossOffset = 0,
  label,
  onClick = () => {},
  className,
  children,
  ref
}) => {
  const classes = classNames(className, style.button, getClassNameForSize(size), getClassNameForPadding(padding, size), getClassNameForColor(color), {
    [style.filled]: filled
  });
  const buttonElement = /* @__PURE__ */jsx(AriaButton, {
    className: classes,
    onPress: onClick,
    isDisabled: disabled,
    isPending: pending,
    type,
    "aria-label": label,
    ref,
    children
  });
  if (tooltip) {
    return /* @__PURE__ */jsxs(TooltipTrigger, {
      delay: 0,
      closeDelay: 0,
      children: [disabled ? /* @__PURE__ */jsx(DisabledButton, {
        className: classes,
        type,
        "aria-label": label,
        ref,
        children
      }) : buttonElement, /* @__PURE__ */jsxs(Tooltip, {
        className: style.tooltip,
        crossOffset: tooltipCrossOffset,
        placement: tooltipPosition,
        children: [/* @__PURE__ */jsx(OverlayArrow, {
          className: style.overlayArrow,
          children: /* @__PURE__ */jsx("svg", {
            width: 12,
            height: 12,
            viewBox: "0 0 12 12",
            children: /* @__PURE__ */jsx("path", {
              d: "M0 0 L6 6 L12 0"
            })
          })
        }), tooltip]
      })]
    });
  }
  return buttonElement;
};
export default Button;
const DisabledButton = ({
  type = "button",
  label,
  onClick = () => {},
  className,
  children
}) => {
  const reactAriaRef = useRef(null);
  let {
    buttonProps
  } = useButton({
    onPress: onClick,
    isDisabled: false,
    type,
    "aria-label": label
  }, reactAriaRef);
  return /* @__PURE__ */jsx("button", __spreadProps(__spreadValues({}, buttonProps), {
    className,
    type,
    "aria-label": label,
    ref: reactAriaRef,
    "aria-disabled": "true",
    children
  }));
};